import * as THREE from 'three';
import TankModel from '../TankModel';

// Adapter around TankModel to decouple GameController from concrete implementation
export default class LocalTankController {
  private impl: TankModel;
  // Expose underlying root object for collidables compatibility
  public tankModel: THREE.Object3D | null = null;

  constructor(scene: THREE.Scene, visualEffectHelper: any, projectileSystem: any = null) {
    this.impl = new TankModel(scene, visualEffectHelper, projectileSystem);
  }

  mountCamera(camera: THREE.Camera) {
    this.impl.mountCamera(camera);
  }

  addToScene(showWireframe: boolean = false, showBoundingBox: boolean = false) {
    this.impl.addToScene(showWireframe, showBoundingBox);
    this.tankModel = this.impl.tankModel;
  }

  setSkin(skinName: string) {
    this.impl.setSkin(skinName);
  }

  setName(name: string) {
    this.impl.setName(name);
  }

  update(deltaTime: number, collidables: any[], inputs: any) {
    this.impl.update(deltaTime, collidables, inputs);
  }

  receiveDamage(damage: number, attackedId: string) {
    this.impl.receiveDamage(damage, attackedId);
  }

  getRoot(): THREE.Object3D | null {
    return this.tankModel;
  }

  // Expose initial network state push (delegates to TankModel)
  sendPlayerUpdate(): void {
    this.impl.sendPlayerUpdate();
  }
}
